import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'
import { pxToNumber } from '../../utils/pxToNumber'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - ${2 * pxToNumber(Spacing.S16)}px);
  margin-bottom: ${Spacing.S12};
  position: absolute;
  right: ${Spacing.S16};
  left: ${Spacing.S16};
  z-index: 1;
  text-align: center;
`

export const Amount = styled.span`
  display: flex;
  align-items: flex-end;
  margin-top: -${Spacing.S4};
  text-align: center;
`

export const Illustration = styled.svg``
